import { Component, Input } from '@angular/core';
import { GeographicalCountrySummary } from '../../data-access/geographical-summary.types';

@Component({
    selector: 'app-country-summary-card',
    templateUrl: './country-summary-card.component.html',
    styleUrls: ['./country-summary-card.component.scss']
})
export class CountrySummaryCardComponent {
    @Input() country: GeographicalCountrySummary | null = null;

    get accessibilityLabel(): string {
        if (!this.country) {
            return 'Unknown';
        }

        return this.country.isAccessible ? 'Accessible' : 'Restricted';
    }

    get averageCapexPerProject(): number {
        if (!this.country || !this.country.projectCount) {
            return 0;
        }

        return this.country.capex / this.country.projectCount;
    }
}
